import { render, staticRenderFns } from "./DraggableFoodCategoriesItems.vue?vue&type=template&id=2ec2b4e0&scoped=true"
import script from "./DraggableFoodCategoriesItems.vue?vue&type=script&lang=js"
export * from "./DraggableFoodCategoriesItems.vue?vue&type=script&lang=js"
import style0 from "./DraggableFoodCategoriesItems.vue?vue&type=style&index=0&id=2ec2b4e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec2b4e0",
  null
  
)

export default component.exports